export function getPath(path: string, pathParams: Record<string, string>) {
  return Object.keys(pathParams).reduce((acc, key) => {
    const value = pathParams[key];
    if (value === undefined) return acc;

    return acc.replace(new RegExp(`\\{${key}\\}`, "g"), value);
  }, path);
}
